import { render, staticRenderFns } from "./restore-appointment.vue?vue&type=template&id=c6a239e0"
import script from "./restore-appointment.vue?vue&type=script&lang=js"
export * from "./restore-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports